<template>
  <div class="container">
    <div class="details">
      <div class="left">
        <a href="/">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <div class="middle">
        <Tabs />
      </div>
      <div class="right">
        <Zoom />
      </div>
    </div>
    <div class="utils">
      <div class="elements">
        <AddItem />
        <Download />
        <Delete />
        <Expand />
      </div>
      <div class="elements">
        <History />
        <Share />
        <Help />
      </div>
    </div>
  </div>
</template>

<script>
import Zoom from './Zoom.vue';
import Share from './TopBar/Share.vue';
import Help from './TopBar/Help.vue';
import Expand from './TopBar/Expand.vue';
import Delete from './TopBar/Delete.vue';
import AddItem from './TopBar/AddItem.vue';
import Download from './TopBar/Download.vue';
import History from './TopBar/History.vue';
import Tabs from './TopBar/Tabs.vue';

export default {
  components: {
    Share,
    Help,
    Delete,
    AddItem,
    Download,
    Expand,
    History,
    Zoom,
    Tabs,
  }
};
</script>

<style lang="less">
.container {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0 0 0 2px rgba(100, 100, 100, .05);
}

.elements {
  display: flex;
  * ~ * {
    margin-left: 20px;
  }
}

.top {
  border-bottom: 1px solid #ededed;
  padding: 0 10px;
  box-sizing: border-box;
}

.details,
.utils {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.utils {
  background: #fbfbfb;
  padding: 8px 10px;
  box-sizing: border-box;
}

.left i {
  cursor: pointer;
}

.el-menu-item.is-disabled {
  opacity: .5;
}

.el-link,
.el-link.el-link--primary {
  margin: 0;
  font-weight: 400;
  font-size: 13px;
}

.el-dropdown-link {
  cursor: pointer;
  font-size: 13px;
}
</style>
